import style from 'containers/MyHealth/components/MyHealthResultsContext/styles'

const themeStyles = colors => {
  const styles = {
    ...style(colors),
    testContainer: {
      display: 'flex'
    },
    learnMoreButton: {
      marginLeft: 0
    },
    text: {
      flexBasis: 'auto',
      width: '30%',
      margin: 0
    }
  }

  styles.textDate = { ...styles.text, padding: '10px 0' }
  styles.textRight = { ...styles.text, padding: '10px 0 0 10px', flex: 1 }
  return styles
}
export default themeStyles
